import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loading", "results"]

  submit() {
    this.loadingTarget.classList.remove("hidden")
    if (this.hasResultsTarget) {
      this.resultsTarget.classList.add("hidden")
    }
  }
}
